import type { Company } from "@domain/CRM/company";
import type { Job } from "@domain/CRM/job";

/**
 * Decides which companies' branches need to be loaded to satisfy the
 * branch-matcher's drop targets:
 *
 *   - If ANY unmatched job has no `companyName`, the admin needs every
 *     branch available to place it — return all companies.
 *   - Otherwise, scope to the companies referenced by the unmatched jobs
 *     (matched by exact `companyName`).
 *
 * Returning a narrower list saves the subsequent batched branch fetch from
 * pulling unrelated branches into the page. Pure: no IO, no React.
 */
export function planBranchLoadScope(jobs: readonly Job[], companies: readonly Company[]): Company[] {
	const hasJobWithoutCompany = jobs.some((j) => !j.companyName);
	if (hasJobWithoutCompany) return [...companies];
	const jobCompanyNames = new Set(jobs.map((j) => j.companyName).filter(Boolean));
	return companies.filter((c) => jobCompanyNames.has(c.name));
}
